export default __webpack_public_path__ + "da12d580902541f5b4d393c801b25dd4.svg";